import { View, Text } from "react-native";
import { ChevronRightIcon, Icon } from "ui/gluestack/icon";
import { Link } from "ui/gluestack/link";

type Props = {
  icon: React.ComponentType;
  label: string;
  href: string;
};

export function ReportNavCard({ icon, label, href }: Props) {
  return (
    <Link
      href={href}
      className="w-full rounded-2xl bg-secondary-0 p-3  hover:bg-secondary-100 flex flex-row items-center justify-between "
    >
      <View className="flex-row items-center gap-3 flex-1">
        <View className="bg-white p-6 rounded-2xl">
          <Icon as={icon} className="w-7 h-7 text-secondary-400" />
        </View>
        <Text className="font-medium text-base flex-shrink">{label}</Text>
      </View>
      <Icon as={ChevronRightIcon} className="w-5 h-5 sm:mr-9 mr-4 shrink-0" />
    </Link>
  );
}
